"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "collecorvino": {
    "6abec90d": [{
      "hkey": "3e78011b",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "fonte": [{
      "hkey": "3e78011b",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "collecorvino"
    }],
    "fa729f40": [{
      "hkey": "99fde703",
      "slug": "barberi",
      "name": "Barberi",
      "primary": true,
      "skipSearch": false
    }],
    "gallo": [{
      "hkey": "99fde703",
      "slug": "barberi",
      "name": "Barberi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "collecorvino"
    }],
    "243eea06": [{
      "hkey": "3e78011b",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "lione": [{
      "hkey": "3e78011b",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "collecorvino"
    }],
    "6c7a14f4": [{
      "hkey": "3e78011b",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "poggio-santa-maria": [{
      "hkey": "3e78011b",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "collecorvino"
    }],
    "cd5219e5": [{
      "hkey": "99fde703",
      "slug": "barberi",
      "name": "Barberi",
      "primary": true,
      "skipSearch": false
    }],
    "renzetti": [{
      "hkey": "99fde703",
      "slug": "barberi",
      "name": "Barberi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "collecorvino"
    }]
  }
};
exports["default"] = _default;